import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';

import { CreatedDateField as CreatedDateView } from '@atlassian/jira-created-date/src/main.tsx';
import { useIssueKey } from '@atlassian/jira-issue-context-service/src/main.tsx';
import { ResolvedDateField as ResolvedDateView } from '@atlassian/jira-resolved-date/src/main.tsx';
import { UpdatedDateField as UpdatedDateView } from '@atlassian/jira-updated-date/src/main.tsx';
import { useUserPreferredWorkItemLayout } from '@atlassian/jira-issue-view-layout/src/services/main.tsx';

const MetaContainerView = () => {
	const issueKey = useIssueKey();
	const { isInWideLayoutExperiment } = useUserPreferredWorkItemLayout();
	return (
		<Box xcss={[containerStyle, isInWideLayoutExperiment && wideViewStyle]}>
			<CreatedDateView issueKey={issueKey} />
			<UpdatedDateView issueKey={issueKey} />
			<ResolvedDateView issueKey={issueKey} />
		</Box>
	);
};
export default MetaContainerView;

const containerStyle = xcss({
	marginTop: 'space.050',
	marginRight: 'space.200',
	flex: 1,
	paddingLeft: 'space.150',
});

const wideViewStyle = xcss({
	display: 'flex',
	gap: 'space.200',
});
